import styles from './PlayerForm.module.css'
import { useLanguage } from '@context/LanguageContext'
import { MAX_NAME_LENGTH } from '../../constants/shared'

function PlayerForm ({
  playerName,
  setPlayerName,
  onAddPlayer,
  isDisabled,
  error
}) {
  const { t } = useLanguage()

  return (
    <>
      <div className={styles.playerForm}>
        <label htmlFor='player-name' className='sr-only'>
          {t.shared.player.formLabel}
        </label>
        <input
          name='player-name'
          id='player-name'
          type='text'
          placeholder={isDisabled ? t.shared.player.maxReached : t.shared.player.placeholder}
          value={playerName}
          onChange={(e) => setPlayerName(e.target.value)}
          disabled={isDisabled}
          maxLength={MAX_NAME_LENGTH}
          className={styles.input}
          aria-describedby='player-error'
        />
        <button
          type='button'
          onClick={onAddPlayer}
          disabled={!playerName.trim() || isDisabled}
          className={styles.button}
        >
          {t.shared.player.add}
        </button>
      </div>
      {error && (
        <p
          className='error-message'
          role='alert'
          aria-live='assertive'
          id='player-error'
        >
          {error}
        </p>
      )}
    </>
  )
}

export default PlayerForm
